import { createAsyncThunk } from '@reduxjs/toolkit'

import JobService from '../../JobService'

import { SEARCH_JOBS } from './jobSearch.actionTypes'

import { defaultErrorMessage } from '../../../constants'

export const searchJobs = createAsyncThunk(SEARCH_JOBS, async (data) => {
  try {
    const response = await JobService.searchJobs(data)

    if (response.data?.error) {
      throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
    }

    return response.data.data
  } catch (error) {
    console.log(error)
    throw error
  }
})
